<script>
export default {
  name: 'dialog.generic',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attrs () {
      return {
        centered: true,
        size: 'lg',
        noCloseOnEsc: true,
        noCloseOnBackdrop: true,
        ...this.$attrs,
        hideHeaderClose: true
      }
    }
  }
}
</script>
<template>
  <b-modal
    :visible="visible"
    body-class="p-0 pb-2"
    header-class="border-bottom py-2 bg-light"
    title-tag="h5"
    title-class="font-weight-light text-primary bg-light font-size-14"
    v-bind="attrs"
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </b-modal>
</template>
